define(function (require) {

    var BaseConnectionsEngagementWidget = require('web-agent-widgets/BaseConnectionsEngagementWidget');

    var MyConnectionsEngagementWidget = BaseConnectionsEngagementWidget.extend({
        ControllerName: "MyConnectionsEngagementWidget",
        applicationType: "MyConnectionsEngagementWidget"
    });

    MyConnectionsEngagementWidget.prototype.onEngagementSelected = function (engagementId) {
        BaseConnectionsEngagementWidget.prototype.onEngagementSelected.call(this, engagementId);

        if (engagementId) {
            lpTag.WebAgent.amsMessagesController.queryMessages(engagementId);
        }
    };

    return MyConnectionsEngagementWidget;

});
